import sitesApi from "../../api/sites";

function initialState() {
  return {
    contact: {
      contactId: null,
      siteId: null,
      salutation: null,
      firstName: null,
      lastName: null,
      title: null,
      phoneNumber: null,
      faxNumber: null,
      address: null,
      city: null,
      state: null,
      zipCode: null,
      email: null,
      authorizedSigner: false,
      studentContact: false
    }
  };
}

const state = initialState;

const getters = {};

const actions = {
  getSiteAddress(context, siteId) {
    sitesApi
      .getSite(siteId)
      .then(function(response) {
        context.commit("updateSiteId", siteId);
        context.commit("updateAddress", response.data.streetAddress);
        context.commit("updateCity", response.data.city);
        context.commit("updateState", response.data.state);
        context.commit("updateZipCode", response.data.zip);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  getContact(context, contactId) {
    sitesApi
      .getSiteContact(contactId)
      .then(function(response) {
        context.commit("updateContact", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  createContact(context) {
    return new Promise((resolve, reject) => {
      sitesApi
        .postSiteContact(context.state.contact)
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },

  editContact(context) {
    return new Promise((resolve, reject) => {
      sitesApi
        .postEditSiteContact(context.state.contact)
        .then(function(response) {
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
};

const mutations = {
  resetForm(state) {
    // acquire initial state
    var initState = initialState();
    // object is iterated over in this way so that the vuex state will remain reactive
    Object.keys(initState).forEach(key => {
      state[key] = initState[key];
    });
  },

  updateSiteId(state, value) {
    state.contact.siteId = value;
  },

  updateContact(state, value) {
    state.contact = value;
  },

  updateSalutation(state, value) {
    state.contact.salutation = value;
  },

  updateFirstName(state, value) {
    state.contact.firstName = value;
  },

  updateLastName(state, value) {
    state.contact.lastName = value;
  },

  updateTitle(state, value) {
    state.contact.title = value;
  },

  updatePhoneNumber(state, value) {
    state.contact.phoneNumber = value;
  },

  updateFaxNumber(state, value) {
    state.contact.faxNumber = value;
  },

  updateAddress(state, value) {
    state.contact.address = value;
  },

  updateCity(state, value) {
    state.contact.city = value;
  },

  updateState(state, value) {
    state.contact.state = value;
  },

  updateZipCode(state, value) {
    state.contact.zipCode = value;
  },

  updateEmail(state, value) {
    state.contact.email = value;
  },

  updateAuthorizedSigner(state, value) {
    state.contact.authorizedSigner = value;
  },

  updateStudentContact(state, value) {
    state.contact.studentContact = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
